import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import SearchBarContainer from '../../../components/SearchBar/SearchBarContainer';
import AdCreateModal from '../../Ads/AdCreateModal/AdCreateModal';
import { connect } from 'react-redux';

class BreadcrumbsAdsTable extends PureComponent {
  state = {
    isAdCreateModalCreated: false,
  }

  handleToggleAddCreateModalOpen = () => {
    this.setState({ isAdCreateModalCreated: !this.state.isAdCreateModalCreated });
  }

  render() {
    const { translations, onSearchClick, tableName, isMobile, t } = this.props;
    const { isAdCreateModalCreated } = this.state;

    return (
      <div className="main-area__header ads-breadcrumbs">
        <AdCreateModal
          isOpen={isAdCreateModalCreated}
          closeModal={this.handleToggleAddCreateModalOpen}
        />

        { isMobile &&
          <div>
            <SearchBarContainer onSearchClick={onSearchClick} tableName={tableName} delay={600} />
            <div className="details__menu">
              <ul>
                {t('table')}
              </ul>

              <button className="btn transparent" onClick={this.handleToggleAddCreateModalOpen}>{t('new_ad')}</button>
            </div>
          </div>
        }

        { !isMobile &&
          <div className="details__menu">
            <ul>
              {t('table')}
            </ul>
          </div>
        }
        { !isMobile && <SearchBarContainer className="qwe" onSearchClick={onSearchClick} tableName={tableName} delay={600} /> }
        { !isMobile && <button className="btn transparent" onClick={this.handleToggleAddCreateModalOpen}>{t('new_ad')}</button> }

        <style jsx="true">{`
          .ads-breadcrumbs {
            display: flex;
            justify-content: space-between;
          }
          button {
            margin: 0;
            padding: 8px 10px;
          }
          @media (max-width: 991px) {
            .details__menu {
              justify-content: space-between;
            }
          }
          @media (min-width: 992px) {
            .ads-breadcrumbs {
              align-items: center;
              padding: 0;
            }
            .details__menu {
              margin-right: auto;
              padding: 15px 30px;
            }
            button {
              margin: 0 30px;
            }
          }
        `}</style>
      </div>
    );
  }
};

BreadcrumbsAdsTable.propTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isMobile: get(state, ['layout', 'isMobile'])
  };
};

export default connect(mapStateToProps)(BreadcrumbsAdsTable);
